import type { Column } from "@tanstack/react-table";
import type { CSSProperties } from "react";
import { twMerge } from "tailwind-merge";

const BASE_CELL_CLASSNAME =
  "px-4.5 py-4 text-[13px] font-semibold text-[#101828] first:pl-[30px] last:pr-[30px]";

export interface CellSizeStyles {
  style: CSSProperties;
  innerStyle?: CSSProperties;
}

export interface BodyCellProps extends CellSizeStyles {
  className: string;
  innerClassName?: string;
}

export function getCellSizeStyles<TData>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  column: Column<TData, any>,
): CellSizeStyles {
  const meta = column.columnDef.meta;
  const fixedSize = meta?.contentFixedSize;
  const grow = meta?.grow;

  if (meta?.naturalWidth) {
    return { style: {} };
  }

  return {
    style: grow ? { minWidth: column.getSize() } : { width: column.getSize() },
    innerStyle: fixedSize
      ? { width: fixedSize }
      : grow
        ? { minWidth: column.getSize() }
        : undefined,
  };
}

export function getBodyCellProps<TData>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  column: Column<TData, any>,
): BodyCellProps {
  const meta = column.columnDef.meta;
  const cellAlignment = meta?.cellAlignment;

  return {
    ...getCellSizeStyles(column),
    className: twMerge(BASE_CELL_CLASSNAME, meta?.cellClassName),
    innerClassName:
      cellAlignment === "right"
        ? "flex justify-end"
        : cellAlignment === "left"
          ? "flex justify-start"
          : cellAlignment === "center"
            ? "flex justify-center"
            : undefined,
  };
}
